import { Button, getPictureProps, Lockup } from '@superhi/design'
import React from 'react'

import { Wrapper, Content, BackgroundImage, Buttons } from './styles'

import { buildPath } from 'src/routing'

const COURSES_URL = buildPath('courses-index')

const backgroundImageProps = getPictureProps({
  small: {
    path: 'https://superhi.amazonaws.com/assets/images/blue-02-header.png',
    width: 100,
  },
  medium: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/blue-02-header.png',
    width: 50,
  },
  large: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/blue-02-header.png',
    width: 60,
  },
  xlarge: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/blue-02-header.png',
    width: 50,
  },
})

const Callout: React.FC<React.PropsWithChildren<{}>> = ({}) => {
  return (
    <Wrapper>
      <BackgroundImage {...backgroundImageProps} fit="cover" alt="" />

      <Content>
        <Lockup
          level="4"
          align="left"
          title="Better together"
          subtitle="Get a discount by adding additional courses to your cart. The more courses, the bigger the discount!"
          subtitleMaxWidth={30}
        />

        <Buttons>
          <Button href={COURSES_URL}>Add more courses</Button>
        </Buttons>
      </Content>
    </Wrapper>
  )
}

export default Callout
